<template>
  <PageWrapper exclude-nav>
    <template #content>
      <div class="text-center mt-16 space-y-4">
        <h1 class="text-8xl font-bold">404</h1>
        <h1 class="text-2xl font-semibold">Page not found</h1>
        <RouterLink to="/" class="mt-16"><button>Go home</button></RouterLink>
      </div>
    </template>
  </PageWrapper>
</template>

<script setup>
import PageWrapper from "@/components/PageWrapper.vue";
</script>
